module.exports = __webpack_public_path__ + "static/linkedlist-2.10-182139e3fd30f1a8b4b83f0e45aa6d8e.png";